/**
 * Real-Executive — identical to the standard Executive Overview, but every
 * backend API call automatically has `?raw=true` appended (handled by the
 * axios interceptor in App.js that fires whenever the browser URL contains
 * "/real-"). This routes all data queries to the `raw` PostgreSQL schema,
 * which holds the pristine pre-override Snowflake snapshot.
 *
 * No visual differences from the standard Executive Overview; only numbers
 * differ — they reflect the live Snowflake data without any Finance-approved
 * overrides (payment cutoff, FY exclusions, Pan-India fan-outs, hardcoded
 * payments, date corrections) applied.
 */
import CommandCentre from "./CommandCentre";

export default function RealExecutive() {
  return <CommandCentre />;
}
